import PublicPageLayout from 'components/PublicPageLayout';
import React from 'react';

const PageNotFound: React.FC = () => {
  return <PublicPageLayout title="404" subtitle="Page Not Found" />;
};

export default PageNotFound;
